// @flow

import { type IncomingPayment } from '../types';
import { normalizeCustomerIncomingPayment } from '../../customer/normalize';

export function normalizeIncomingPayment<T: IncomingPayment>(incomingPayment: T): T {
  return normalizeCustomerIncomingPayment<T>(incomingPayment);
}
